import gql from 'graphql-tag'

export const WATER_TESTING_MAP_PIN_INFO_QUERY = gql`
  query waterTestingMapPinInfo($facilityId: Int!) {
    info: waterTestingMapPinInfo(facilityId: $facilityId) {
      facilityName
      address
      city
      state
      zip
      fixtureCount
      sampleCount
      exceedanceCount
    }
  }
`
